import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/article/${movie.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
      data-product-shop
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={movie.image}
          alt={`${movie.title} - 琪琪影院高清在线观看`}
          title={`${movie.title} - 琪琪影院高清在线观看`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2">
          <span className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-primary-500 text-white">
            {movie.rating}
          </span>
        </div>
        {movie.type === 'tv' && (
          <div className="absolute top-2 right-2">
            <span className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-accent-500 text-white">
              剧集
            </span>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <span className="text-white text-xs font-medium bg-primary-500/90 px-3 py-1.5 rounded-full whitespace-nowrap">立即观看</span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-xs text-foreground-500">{movie.year}</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-foreground-500">{movie.duration}</span>
        </div>
      </div>
    </Link>
  );
}